import type { ChipId } from './types'

/**
 * The numbers that make chips scarce, in a module with nothing but a type import.
 *
 * They used to live in `useGameweekChips.ts`, a React hook that pulls in lucide-react icons, so
 * the API process could not read them. The server enforces the same rules the UI shows, and
 * re-typing the numbers in `server/` would put the cheat gate and the UI on separate clocks.
 */

/** After a first use, a chip's second use is locked until this gameweek. */
export const SECOND_UNLOCK_GW = 19

// How many charges each chip gets a season, and the only place the number lives — the predict
// page's pips, the profile tiles and the server's ledger check all read it from here, so they
// can't drift apart.
export const CHIP_SEASON_CAPS: Record<ChipId, number> = {
  doubleUp: 2,
  cleanSweep: 2,
  goalfest: 2,
}
